import * as actions from "./actionTypes";
import axios from "../../axios_call";
import { BASE_URL } from "../../components/Helpers/helpers";

const transactionReconciledListStart = () => {
  return {
    type: actions.TRANSACTION_LIST_START,
  };
};

const transactionReconciledListFail = (error) => {
  return {
    type: actions.TRANSACTION_LIST_FAIL,
    error: error,
  };
};

const transactionReconciledListSuccess = (message, data, page) => {
  return {
    type: actions.TRANSACTION_LIST_SUCCESS,
    message: message,
    data: data,
    page: page,
  };
};

const transactionReconciledDeleteAction = (id) => {
  return {
    type: actions.TRANSACTION_DELETE,
    id: id,
  };
};

const transactionReconciledAddEditStart = () => {
  return {
    type: actions.TRANSACTION_ADD_EDIT_START,
  };
};

const transactionReconciledAddEditFail = (error) => {
  return {
    type: actions.TRANSACTION_ADD_EDIT_FAIL,
    error: error,
    redirectTo: null,
  };
};

const transactionReconciledAddEditSuccess = (message, data) => {
  return {
    type: actions.TRANSACTION_ADD_EDIT_SUCCESS,
    message: message,
    data: data,
    redirectTo: "/transactions",
  };
};

const transactionReconciledDetail = (data, error) => {
  return {
    type: actions.TRANSACTION_DETAIL,
    data: data,
    error: error,
  };
};

const transactionReconciledfilterList = (text) => {
  return {
    type: actions.TRANSACTION_LIST_FILTER,
    text: text,
  };
};
const constructUrlWithParams = (baseUrl, params) => {
  const query = Object.keys(params)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
    )
    .join("&");
  return `${baseUrl}?${query}`;
};

export const transactionReconciledList = (params) => {
  return (dispatch) => {
    dispatch(transactionReconciledListStart());

    const url = constructUrlWithParams(`${BASE_URL}/transaction/reconciled`, params);

    axios
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          const data = response.data.data;
          const msg = response.data.message;
          dispatch(transactionReconciledListSuccess(msg, data, params.page));
        } else {
          dispatch(transactionReconciledListFail(response.message));
        }
      })
      .catch((error) => {
        dispatch(transactionReconciledListFail(error.message));
      });

    dispatch(transactionReconciledListSuccess("Data Successfully.", [{}, {}, {}], 1));
  };
};
export const getAlltransactionReconciled = (params) => {
  return (dispatch) => {
    return axios
      .get(`${BASE_URL}/transaction/getAllTransaction`)
      .then((response) => {
        if (response.status === 200) {
          dispatch(transactionReconciledDetail(response.data, "")); // Dispatch the data
          return response; // Return the response for async handling
        } else {
          dispatch(transactionReconciledDetail(null, "Invalid transaction detail"));
          return { data: null }; // Return something even in error cases
        }
      })
      .catch((error) => {
        dispatch(transactionReconciledDetail(null, error.message));
        return { data: null }; // Return something even on error
      });
  };
};
export const transactionReconciledDelete = (id, token) => {
  return (dispatch) => {
    axios
      .delete("SuperAdmin/deletetransaction?transactionid=" + id)
      .then((response) => {
        if (response.data.status) {
          dispatch(transactionReconciledDeleteAction(id));
        }
      });
  };
};

export const gettransactionReconciledDetail = (id) => {
  return (dispatch) => {
    return axios
      .get(`${BASE_URL}/transaction/transaction-detail/${id}`)
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch(transactionReconciledDetail(response.data, "")); // Dispatch the data
          return response; // Return the response for async handling
        } else {
          dispatch(transactionReconciledDetail(null, "Invalid transaction detail"));
          return { data: null }; // Return something even in error cases
        }
      })
      .catch((error) => {
        dispatch(transactionReconciledDetail(null, error.message));
        return { data: null }; // Return something even on error
      });
  };
};

export const TransactionReconciledDetail = (id) => {
  return (dispatch) => {
    axios.get("SuperAdmin/gettransactionbyid?id=" + id).then((response) => {
      if (response.data.result) {
        dispatch(transactionReconciledDetail(response.data.result, ""));
      } else {
        dispatch(transactionReconciledDetail(null, "Invalide transaction Detail"));
      }
    });
  };
};

export const transactionReconciledAddEdit = (param) => {
  return (dispatch) => {
    dispatch(transactionReconciledAddEditStart());
    axios
      .post("SuperAdmin/addupdatetransaction", param)
      .then((response) => {
        if (response.data.status) {
          const data = response.data.result;
          const msg = response.data.message;
          dispatch(transactionReconciledAddEditSuccess(msg, data));
        } else {
          dispatch(transactionReconciledAddEditFail(response.data.message));
        }
      })
      .catch((error) => {
        dispatch(transactionReconciledAddEditFail(error.message));
      });
  };
};

export const addEditTransactionReconciledErrorNull = () => {
  return (dispatch) => {
    dispatch(transactionReconciledAddEditFail(null));
  };
};

export const transactionReconciledListFilter = (filterText) => {
  return (dispatch) => {
    dispatch(transactionReconciledfilterList(filterText));
  };
};
